import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EstimateProvider } from "./components/EstimateContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Commercial from "./pages/Commercial";
import KitchenRenovations from "./pages/KitchenRenovations";
import BathroomRenovations from "./pages/BathroomRenovations";
import BasementDevelopment from "./pages/BasementDevelopment";
import LegalSuites from "./pages/LegalSuites";
import FullHomeRemodeling from "./pages/FullHomeRemodeling";
import ServiceArea from "./pages/ServiceArea";
import DesignStudio from "./pages/DesignStudio";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Contact from "./pages/Contact";
import ChatWidget from "./components/ChatWidget";
import AdminApp from "./admin/AdminApp";

function PublicSite() {
  return (
    <EstimateProvider>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/kitchen" element={<KitchenRenovations />} />
          <Route path="/services/bathroom" element={<BathroomRenovations />} />
          <Route path="/services/basement" element={<BasementDevelopment />} />
          <Route path="/services/legal-suites" element={<LegalSuites />} />
          <Route path="/services/full-home" element={<FullHomeRemodeling />} />
          <Route path="/services/design-studio" element={<DesignStudio />} />
          <Route path="/service-areas" element={<ServiceArea />} />
          <Route path="/service-areas/:slug" element={<ServiceArea />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
      <Toaster />
    </EstimateProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
